import React from "react";

import { ItemShareDialog } from "#app/components/issue-actions/item-share-dialog";

type ItemShareDialogActions = {
  openDialog: (issueId: string) => void;
  closeDialog: () => void;
};

// Same emitter trick as custom-fields-dialog-context — callers that
// live inside bottom-sheet portals (kanban card menus on mobile, the
// issue-view three-dot menu, etc.) can't read React context, so we
// route open/close through a module-scoped Set instead.
type Listener = (issueId: string | null) => void;
const listeners = new Set<Listener>();
function emit(issueId: string | null) {
  listeners.forEach((l) => l(issueId));
}

export function useItemShareDialogActions(): ItemShareDialogActions {
  return React.useMemo<ItemShareDialogActions>(
    () => ({
      openDialog: (issueId: string) => emit(issueId),
      closeDialog: () => emit(null),
    }),
    [],
  );
}

export function ItemShareDialogMount() {
  const [issueId, setIssueId] = React.useState<string | null>(null);

  React.useEffect(() => {
    listeners.add(setIssueId);
    return () => {
      listeners.delete(setIssueId);
    };
  }, []);

  return (
    <ItemShareDialog
      issueId={issueId}
      onOpenChange={(open) => {
        if (!open) setIssueId(null);
      }}
    />
  );
}
